import { ISearchNodes } from '@/contracts/modules/libre/use-case/ISearchNodes'
import { ILibreTree } from '@/contracts/modules/libre/use-case/ILibreTree'
import { ILibreFilter } from '@/contracts/modules/libre/entities/ILibreFilter'
import { ILibreFound } from '@/contracts/modules/libre/entities/ILibreFound'
import { ILibreNode } from '@/contracts/modules/libre/entities/ILibreNode'
import { EnumLibreDirection } from '@/contracts/modules/libre/enum/EnumLibreDirection'

/** Текст узла для поиска подстроки: содержимое, свои теги и особенности вида */
function textOf(node: ILibreNode): string {
  return [node.getContent(), ...node.getTags(), ...Object.values(node.getAttrs())].join('\n').toLowerCase()
}

export class SearchNodes implements ISearchNodes {
  exec(tree: ILibreTree, filter: ILibreFilter): ILibreFound[] {
    const needle = filter.text.trim().toLowerCase()
    return this.candidates(tree, filter)
      .filter((node) => filter.kinds.length === 0 || filter.kinds.includes(node.getKind()))
      .filter((node) => {
        const tags = tree.effectiveTags(node.getUuid())
        return filter.tags.every((tag) => tags.includes(tag))
      })
      .filter((node) => needle === '' || textOf(node).includes(needle))
      .filter((node) => filter.date === null || node.isActualOn(filter.date))
      .map((node) => ({ node, path: tree.ancestors(node.getUuid()) }))
  }

  private candidates(tree: ILibreTree, filter: ILibreFilter): ILibreNode[] {
    if (filter.branch === null || tree.isHidden(filter.branch)) {
      return tree.all()
    }
    switch (filter.direction) {
    case EnumLibreDirection.UP:
      return tree.ancestors(filter.branch)
    case EnumLibreDirection.AROUND:
      return tree.around(filter.branch, Math.max(0, filter.depth))
    default:
      return tree.descendants(filter.branch)
    }
  }
}
